import { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import {
    ASSET_FRAGMENT,
    GET_ASSET_ITEM,
    GetAssetItemQuery,
    GetAssetItemQueryVariables,
    getFragmentData,
} from '@deltasierra/frontend-graphql-core';
import { Asset, AssetWithDimensions } from '../types';

export const useThumbnailPoller = (asset: Asset | AssetWithDimensions): void => {
    const { client, data, stopPolling } = useQuery<GetAssetItemQuery, GetAssetItemQueryVariables>(GET_ASSET_ITEM, {
        notifyOnNetworkStatusChange: true,
        pollInterval: 10_000,
        variables: { assetId: asset.id },
    });

    useEffect(() => {
        if (!data) {
            return;
        }

        if (data.asset && data.asset.__typename === 'AssetFile') {
            const currentAsset = getFragmentData(ASSET_FRAGMENT, data.asset);
            if (currentAsset.__typename === 'AssetFile') {
                const thumbnails = currentAsset.thumbnails;
                if (thumbnails) {
                    client.cache.modify({
                        fields: {
                            thumbnails: () => thumbnails,
                        },
                        id: `AssetFile:${asset.id}`,
                    });
                    stopPolling();
                } else {
                    return;
                }
            }
        }
        stopPolling();
        // eslint-disable-next-line consistent-return
        return () => {
            stopPolling();
        };
    }, [data, asset, client, stopPolling]);
};
